import { createAsyncThunk } from '@reduxjs/toolkit';
import { isNotDefined } from '@sgme/fp';

import type { AppState } from '@/store/store.ts';
import { swapApi } from '@/store/swap/api/index.ts';
import { selectSwapTile } from '@/store/swap/selectors/tile.ts';
import { swapReseted } from '@/store/swap/slice.ts';
import { getSwapTradeCaptureQueue } from '@/store/swap/swapTradeCaptureQueue.ts';

export const resetSwap = createAsyncThunk('cash/reset', (tileId: string, thunkAPI) => {
  const currentState = thunkAPI.getState() as AppState;

  // swap must be reseted locally first
  // because trade capture doesn't reset payment date to null / undefined
  thunkAPI.dispatch(swapReseted({ tileId, userPreferences: currentState.userPreferences }));

  const updatedState = thunkAPI.getState() as AppState;
  const resetedTile = selectSwapTile(updatedState, tileId);

  if (
    isNotDefined(resetedTile) ||
    isNotDefined(resetedTile.type) ||
    isNotDefined(resetedTile.tradeCapture) // ||
  ) {
    return;
  }

  void getSwapTradeCaptureQueue(tileId).add(async () => {
    await thunkAPI.dispatch(
      // @ts-expect-error ok, it is only for NDS
      swapApi.endpoints.checkSwapByTradeCapture.initiate({
        tileId,

        isNonDeliverable: resetedTile.isNonDeliverable,

        properties: {
          ...resetedTile.properties,

          nearNotional: resetedTile.properties.nearNotional ?? null,
          nearNotionalCurrencyIndex: resetedTile.properties.nearNotionalCurrencyIndex ?? null,
          nearExpiryDate: resetedTile.properties.nearExpiryDate ?? resetedTile.properties.nearExpiryDateTenor ?? 'SP',
          nearPrice: null,

          farNotional: resetedTile.properties.farNotional ?? null,
          farNotionalCurrencyIndex: resetedTile.properties.farNotionalCurrencyIndex ?? null,
          farExpiryDate: resetedTile.properties.farExpiryDate ?? null,
          farExpiryDateTenor: resetedTile.properties.farExpiryDateTenor ?? null,
          farPrice: null,
        },
      }),
    );
  });
});
